<template>

  <div class="profile-menu">
    <div class="profile-button-wrapper">
      <div class="profile-button-container">
        <gps-checkin />

        <v-btn to="coupon-scan" color="primary" v-if="hasLoyaltyScan">
          <v-icon small left>{{icons.mdiQrcode}}</v-icon>
          <span v-if="$store.getters.loyaltyScan.couponEnabled">{{ $t('couponScan.couponScanButtonText')}}</span>
          <span v-else>{{ $t('couponScan.invoiceRksvScanButtonText')}}</span>
        </v-btn>

        <v-btn @click="openFriendsInvite" color="primary" v-if="friendInvites && inviteUrl" class="friends-invite">
          <v-icon small left>{{icons.mdiAccountPlus}}</v-icon>
          {{$t('friendInvite.friendInviteButton')}}
        </v-btn>

      </div>
    </div>

    <v-dialog v-model="friendsInviteDialog" max-width="310" persistent v-if="friendInvites">
      <v-card>
        <button class="close" @click="friendsInviteDialog = false"><v-icon>{{icons.mdiClose}}</v-icon></button>
        <v-card-title class="headline">{{$t('friendInvite.friendInviteDialogTitle')}}</v-card-title>
        <v-card-text>
          {{ $t('friendInvite.friendInviteDialogDescription', {inviterAcceptPoints: friendInvites.inviter_accept_points}) }}
          <v-divider class="mt-4"/>
          <div class="subtitle-1 py-2">Code: <span class="font-weight-bold primary--text">{{ customerRelationship.invite_code }}</span></div>
          <v-divider />
        </v-card-text>

        <v-card-actions v-if="inviteUrl">
          <v-spacer></v-spacer>

          <v-btn color="primary" text @click="openShare" v-if="shareApi">
            {{$t('friendInvite.friendInviteDialogButtonText')}}
          </v-btn>

          <div class="share-list text-center" v-else>
            <vue-goodshare-facebook :page_url="inviteUrl" has_icon></vue-goodshare-facebook>
            <vue-goodshare-whats-app :page_url="inviteUrl" has_icon></vue-goodshare-whats-app>
            <vue-goodshare-email :page_url="inviteUrl" has_icon></vue-goodshare-email>
            <button class="copy" v-clipboard:copy="inviteUrl" v-clipboard:success="onCopy" v-clipboard:error="onCopyError">
              <v-icon small>{{icons.mdiContentCopy}}</v-icon>
            </button>
          </div>
        </v-card-actions>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="copySlipboardSnackbar" :timeout="2000">
      {{$t('friendInvite.friendInviteCopiedToClipboard')}}
    </v-snackbar>

  </div>
</template>

<script>
  import _ from 'lodash'
  import {mdiAccountPlus, mdiContentCopy, mdiClose, mdiCamera, mdiQrcode} from '@mdi/js';
  import {mapGetters} from 'vuex';
  import GpsCheckin from '@/components/profile/GPSCheckin';
  import isFeatureSupported from '@/utils/isFeatureSupported';
  import VueGoodshareFacebook from "vue-goodshare/src/providers/Facebook.vue";
  import VueGoodshareEmail from "vue-goodshare/src/providers/Email.vue";
  import VueGoodshareWhatsApp from "vue-goodshare/src/providers/WhatsApp.vue";

  export default {
    name: 'ProfileMenu',
    components: {
      VueGoodshareFacebook, VueGoodshareEmail, VueGoodshareWhatsApp, GpsCheckin
    },
    data: () => ({
      icons: {mdiAccountPlus, mdiContentCopy, mdiClose, mdiCamera, mdiQrcode},
      friendsInviteDialog: false,
      copySlipboardSnackbar: false
    }),
    computed: {
      ...mapGetters(['extensionSettings', 'customerRelationship']),
      hasLoyaltyScan() {
        return this.$store.getters.loyaltyScan.hasLoyaltyScan && isFeatureSupported('cameraStream');
      },
      friendInvites() {
        return _.get(this.extensionSettings, 'friend-invites');
      },
      inviteUrl() {
        return _.get(this.friendInvites, 'invite_url', false) ? this.friendInvites.invite_url + `?invite_code=${this.customerRelationship.invite_code}` : false
      },
      shareUrl() {
        return this.friendInvites.invite_share_url
      },
      shareApi() {
        return navigator && navigator.share
      }
    },
    methods: {
      openFriendsInvite() {
        this.friendsInviteDialog = true;
      },
      onCopy() {
        this.copySlipboardSnackbar = true;
      },
      onCopyError() {
        alert(this.$t('friendInvite.friendInviteCopiedToClipboardError'));
      },
      openShare() {
        navigator.share({
          title: '',
          text: this.$tc('friendInvite.friendInviteShareMessage', this.friendInvites.invitee_accept_points, {count: this.friendInvites.invitee_accept_points, inviteCode: this.customerRelationship.invite_code}),
          url: this.inviteUrl
        });
      }
    }
  }
</script>

<style scoped lang="scss">
  .close {
    position: absolute;
    right: 4px;
    top: 4px;
  }
  .share-list {
    display: flex;
  }
  .copy {
    display: inline-flex;
    cursor: pointer;
    padding: 4px 7px;
    padding: 8px 12px;
    margin: 3px 1.5px;
    border-radius: 3px;
    border: 1px solid rgba(0, 0, 0, 0.1);
    background-color: rgb(236, 236, 236);
    box-sizing: border-box;
  }
  .profile-button-wrapper {
    display: flex;
    justify-content: center
  }
  .profile-button-container {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }
  @media (min-width: 600px) {
   .profile-button-container {
      flex-direction: row;
      justify-content: center;
    }
  }
  .profile-button-container {
    &::v-deep a.v-btn {
      display: flex;
      align-items: center;
    }
    &::v-deep .v-btn {
      min-width: 200px;
      &:last-child {
        margin-bottom: 0;
      }
      &.v-btn--is-elevated {
        box-shadow: none;
      }
    }
  }
</style>
